import { describeMutation } from '@siteless/resource';
import ObjectiveStateResource, { ObjectiveStateResourceType } from '.';
import { ObjectiveStateCeremonyDetails } from './CeremonyDetails';

export const acceptObjectiveStateChangeMutation = describeMutation(
  'acceptObjectiveStateChange',
  async (coreData: Partial<ObjectiveStateResourceType>) => {
    await ObjectiveStateCeremonyDetails.yield(
      undefined,
      (identity: undefined, last: ObjectiveStateResourceType) => {
        return {
          ...last,
          ...coreData,
        };
      },
    );
    await ObjectiveStateResource.yield(
      undefined,
      (identity: undefined, last: ObjectiveStateResourceType) => {
        return {
          ...last,
          ...coreData,
        };
      },
    );
  },
);
